import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=0a03a050"
import script from "./WaitView.vue?vue&type=script&lang=js"
export * from "./WaitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports